import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHypertrackerAlertsMenuMobileIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M6.23612 14C6.70621 14.4149 7.32371 14.6667 8 14.6667C8.6763 14.6667 9.2938 14.4149 9.76389 14M12 5.33334C12 4.27248 11.5786 3.25506 10.8284 2.50492C10.0783 1.75477 9.06087 1.33334 8 1.33334C6.93914 1.33334 5.92172 1.75477 5.17158 2.50492C4.42143 3.25506 4 4.27248 4 5.33334C4 7.39347 3.48032 8.80398 2.89978 9.73695C2.41009 10.5239 2.16524 10.9174 2.17422 11.0272C2.18416 11.1487 2.20991 11.1951 2.30785 11.2677C2.39631 11.3333 2.79506 11.3333 3.59257 11.3333H12.4074C13.2049 11.3333 13.6037 11.3333 13.6922 11.2677C13.7901 11.1951 13.8158 11.1487 13.8258 11.0272C13.8348 10.9174 13.5899 10.5239 13.1002 9.73695C12.5197 8.80398 12 7.39347 12 5.33334Z",
		stroke: "#1A1B23",
		strokeWidth: 1.33333,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M6.23612 14C6.70621 14.4149 7.32371 14.6667 8 14.6667C8.6763 14.6667 9.2938 14.4149 9.76389 14M12 5.33334C12 4.27248 11.5786 3.25506 10.8284 2.50492C10.0783 1.75477 9.06087 1.33334 8 1.33334C6.93914 1.33334 5.92172 1.75477 5.17158 2.50492C4.42143 3.25506 4 4.27248 4 5.33334C4 7.39347 3.48032 8.80398 2.89978 9.73695C2.41009 10.5239 2.16524 10.9174 2.17422 11.0272C2.18416 11.1487 2.20991 11.1951 2.30785 11.2677C2.39631 11.3333 2.79506 11.3333 3.59257 11.3333H12.4074C13.2049 11.3333 13.6037 11.3333 13.6922 11.2677C13.7901 11.1951 13.8158 11.1487 13.8258 11.0272C13.8348 10.9174 13.5899 10.5239 13.1002 9.73695C12.5197 8.80398 12 7.39347 12 5.33334Z",
		stroke: "white",
		strokeOpacity: .5,
		strokeWidth: 1.33333,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgHypertrackerAlertsMenuMobileIcon;
